import useGlobalStore from '../../store/globalStore'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { axiosPrivate } from '../../api/axiosClient'
import { apiEndpoints, queryKeys } from '../../constants'

const useUpdateReportedPic = (page, searchTerm, handleConfirmModalClose) => {
  const queryClient = useQueryClient()
  const showToastMessage = useGlobalStore((state) => state.showToastMessage)

  const { mutate, isLoading } = useMutation(
    (payload) => axiosPrivate.post(`${apiEndpoints.reportedPics}`, payload),
    {
      onSuccess: (response) => {
        const successMessage =
          response?.data?.message || 'Successfully updated the reported photo'

        showToastMessage(successMessage, 'success')
      },
      onError: (error) => {
        const errorMessage =
          error?.errors?.message ||
          'Error occurred while updating reported photo'

        showToastMessage(errorMessage, 'error')
      },
      onSettled: () => {
        handleConfirmModalClose()
        queryClient.invalidateQueries([
          queryKeys.reportedPics,
          page,
          searchTerm,
        ])
      },
    },
  )

  return { updateReportedPic: mutate, isUpdatingReportedPic: isLoading }
}

export default useUpdateReportedPic
